module.exports = __webpack_public_path__ + "static/media/account_dash_icon.e6ce2e7e.svg";